import { render, staticRenderFns } from "./ServicePlan.vue?vue&type=template&id=83c2bd58&scoped=true&"
import script from "./ServicePlan.vue?vue&type=script&lang=js&"
export * from "./ServicePlan.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/project-manage.css?vue&type=style&index=0&id=83c2bd58&scoped=true&lang=css&"
import style1 from "./ServicePlan.vue?vue&type=style&index=1&id=83c2bd58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c2bd58",
  null
  
)

export default component.exports